module.exports = __webpack_public_path__ + "img/10.2d41ce64.png";